import { Skeleton } from '@/components/ui/skeleton'
import { Card, CardContent } from '@/components/ui/card'

const GameroomScenarioSettingsSkeleton = () => {
  return (
    <div className='py-6 px-24 space-y-6 relative'>
      <Skeleton className='h-8 w-64' />
      <Skeleton className='h-5 w-full max-w-lg' />

      <div className='space-y-6'>
        <div>
          <Skeleton className='h-5 w-32 mb-2' />
          <Skeleton className='h-10 w-full' />
        </div>

        <div className='space-y-4'>
          <Card className='p-4 space-y-4 relative'>
            <CardContent className='space-y-2'>
              <Skeleton className='h-5 w-24 mb-2' />
              <Skeleton className='h-10 w-full' />

              <Skeleton className='h-5 w-24 mb-2' />
              <Skeleton className='h-28 w-full' />
            </CardContent>
          </Card>

          <Card className='p-4 space-y-4 relative'>
            <CardContent className='space-y-2'>
              <Skeleton className='h-5 w-24 mb-2' />
              <Skeleton className='h-10 w-full' />

              <Skeleton className='h-5 w-24 mb-2' />
              <Skeleton className='h-28 w-full' />
            </CardContent>
          </Card>
        </div>

        <div className='flex justify-start gap-2'>
          <Skeleton className='h-10 w-32 rounded-md' />
          <Skeleton className='h-10 w-32 rounded-md' />
        </div>
      </div>
    </div>
  )
}

export default GameroomScenarioSettingsSkeleton
